import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { urlSnapshotToRedirectPath } from '@core/utils/url-snapshot-to-redirect-path';

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.whenReady();

  if (!auth.isAuthenticated) {
    const redirectParams = urlSnapshotToRedirectPath();
    const loginUrl = router.createUrlTree(['/entrar'], { queryParams: redirectParams });
    return new RedirectCommand(loginUrl);
  }

  return true;
};
